<div id="create-valores-popup" class="common-company-popup popup-sm">
    <form class="form" role="form" autocomplete="off" [formGroup]="addValoresActualesForm">
        <div class="popoup-hearder">
            <h2 class="m-b-5" mat-dialog-title>Valores actuales</h2>
        </div>
        <div class="popoup-content">
            <div class="block-looper">
                <div class="form-wrap">
                    <mat-label class="label">Valore</mat-label>
                    <mat-form-field appearance="fill">
                        <input formControlName="texto" matInput placeholder="">
                    </mat-form-field>
                    <mat-error
                    *ngIf="addValoresActualesForm.get('texto').invalid && addValoresActualesForm.get('texto').touched">
                    <span *ngIf="addValoresActualesForm.get('texto').hasError('required')"> El valore es obligatorio</span>
                    </mat-error>
                </div>
            </div>
        </div>
        <div class="popoup-footer">
            <button class="keep"><span (click)="saveValoresActuales()" class="mat-button-wrapper">Guardar</span></button>
            <button class="cancel" (click)="cancel()"><span class="mat-button-wrapper">Cancelar</span></button>
        </div>
    </form>
</div>